module.exports = __webpack_public_path__ + "static/media/Change Pasword - Password Link.301e247d.png";